import { useEffect, useState } from "react";

function useDeviceType() {
  const [deviceType, setDeviceType] = useState("desktop");

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();

    if (
      /mobile|iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(ua)
    ) {
      setDeviceType("mobile");
    } else if (/ipad|tablet|kindle/i.test(ua)) {
      setDeviceType("tablet");
    } else {
      setDeviceType("desktop");
    }
  }, []);

  return deviceType;
}

export default useDeviceType;
